import { z } from 'zod'

import { optional, required } from './schemaHelpers'

export const buildHotelServiceSchema = () =>
  z.object({
    checkInDate: required(),
    checkOutDate: required(),
    hotelCity: required(),
    hotelName: optional(),
    hotelStars: optional(),
    hotelParking: optional(),
    treatment: optional(),
    noteAggiuntive: optional()
  })
